import "./style.less";
import SearchBar from "./directive";
import SearchBarCalender from "./calender";
import SearchBarActivity from "./activity";
import SearchBarTime from "./time";

import SearchBarLocation from "./location";

const modul = angular
    .module("SearchBarComponents", [SearchBarCalender, SearchBarTime])

    .directive("searchBar", SearchBar)
    .directive("searchBarActivity", SearchBarActivity)
    .directive("searchBarLocation", SearchBarLocation);

export default modul.name;
